import { useAppSelector } from "@app/hooks"
import {
  selectCourseInstanceByIdentifiers,
  selectInstancesByCourseId,
} from "@features/courseInstance/courseInstanceSelectors"
import useSpecificSearchParam from "@utils/hooks/useSpecificSearchParams"
import { useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"

export const CourseInstanceRedirect = () => {
  const { courseId: courseIdParam } = useParams()
  // Content-progress and calendar shortcuts link with a CourseDescriptorDto id,
  // which is versioned (uuid.major.minor). Course instances key on the base
  // course id, so strip the version before resolving or nothing matches and the
  // page renders blank.
  const courseId = courseIdParam?.split(".")[0]
  const [termIdFromParam] = useSpecificSearchParam("termId")
  const navigate = useNavigate()
  const courseInstances = useAppSelector((state) =>
    selectInstancesByCourseId(state, courseId),
  )
  const selectedInstance = useAppSelector((state) =>
    selectCourseInstanceByIdentifiers(
      state,
      courseId,
      termIdFromParam,
      undefined,
    ),
  )

  useEffect(() => {
    if (!courseId) {
      return
    }
    if (selectedInstance) {
      navigate(`/course-manager/course-instance/${selectedInstance.id}`)
      return
    } else if (courseInstances.length > 0) {
      const instance = courseInstances[0]
      navigate(`/course-manager/course-instance/${instance.id}`)

      return
    }
  }, [courseId, navigate, selectedInstance, courseInstances])

  return null
}
